import { render, staticRenderFns } from "./stage23.vue?vue&type=template&id=10e98222&scoped=true&"
import script from "./stage23.vue?vue&type=script&lang=js&"
export * from "./stage23.vue?vue&type=script&lang=js&"
import style0 from "./stage23.vue?vue&type=style&index=0&id=10e98222&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e98222",
  null
  
)

export default component.exports